$(function() {
    showFilterCount();

    $(window).resize(showFilterCount);

    $('.js-checkbox').on('change', function() {
        if ($(window).width() < 768) return;

        const $optionsWrap = this.closest('.js-options');
        const $optionsToggle = $($optionsWrap).siblings('.js-options-btn');
        const $optionsText = $optionsToggle.find('.js-options-count');
        const $checkboxList = $($optionsWrap).find('.js-checkbox-label');
        const defaultText = $optionsToggle.data('default');

        $($optionsText).text(renderValue(defaultText, $checkboxList));
    });

    function showFilterCount() {
        const $optionsWraps = $('.js-options');

        for (let i = 0; i < $optionsWraps.length; i++) {
            const $optionsToggle = $($optionsWraps[i])
                .siblings('.js-options-btn');
            const $optionsText = $optionsToggle.find('.js-options-count');
            const $checkboxList = $($optionsWraps[i])
                .find('.js-checkbox-label');
            const defaultText = $optionsToggle.data('default');

            if ($(window).width() < 768) {
                $($optionsText)
                    .text(defaultText + ' (' + $checkboxList.length + ')');
            } else {
                $($optionsText).text(renderValue(defaultText, $checkboxList));
            }
        }
    }

    function renderValue(defaultValue, inputAarray) {
        const checkedList = inputAarray.filter((i, item) =>
            $(item).find('.js-checkbox').is(':checked')
        );

        if (checkedList.length === 1) {
            return $(checkedList[0]).text();
        }

        if (checkedList.length === inputAarray.length ||
            checkedList.length === 0) {

            return 'All ' + defaultValue;
        }

        return defaultValue + ' (' + checkedList.length + ')';
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/category/filter-field.js